import React from 'react';
import './Banner.scss';
import TextUnderline from '../../Component/TextUnderline/TextUnderline';
import { useTranslation } from 'react-i18next';

function Banner() {
  const { t } = useTranslation();

  return (
    <div className="banner">
      <div className="banner-left">
        <div className="banner-left-content">
          <div className="banner-title">
            <TextUnderline
              className="banner-title"
              style={{ textTransform: 'capitalize', color: '#fff' }}
            >
              {t('banner.title')}
            </TextUnderline>
            <br />
            <br />
            <TextUnderline
              className="banner-title"
              style={{ textTransform: 'uppercase', color: '#fff' }}
            >
              {t('banner.location')}
            </TextUnderline>
          </div>
          <div className="banner-desc">
            {t('banner.address').split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < t('banner.address').split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className="banner-right"></div>
    </div>
  );
}

export default Banner;
